/* Vid Natur mobile navigation: independent of the legacy drawer listeners. */
(() => {
  'use strict';
  // Theme editor section reloads can execute this asset again.
  if (window.vnMobileMenu20261007) {
    window.vnMobileMenu20261007.start();
    return;
  }
  const controllers = new Map();
  const mobile = window.matchMedia('(max-width: 990px)');

  function initialize(header) {
    if (controllers.has(header)) return;
    const toggle = header.querySelector('[data-vn-mobile-toggle]');
    const dialog = header.querySelector('[data-vn-mobile-drawer]');
    const panel = dialog?.querySelector('.vn-drawer__panel');
    if (!toggle || !dialog || !panel) return;
    const abort = new AbortController();
    const listen = (node, type, handler) => node.addEventListener(type, handler, { signal: abort.signal });
    const isOpen = () => dialog.hasAttribute('open');
    let opener = null;
    let activeEntry = null;
    const home = dialog.querySelector('[data-menu-home]');
    const views = [...dialog.querySelectorAll('[data-menu-view]')];
    const entries = [...dialog.querySelectorAll('[data-menu-enter]')];

    function showHome(restoreFocus = false) {
      home.hidden = false;
      home.inert = false;
      entries.forEach(entry => entry.setAttribute('aria-expanded', 'false'));
      dialog.setAttribute('aria-labelledby', dialog.id + '-title');
      if (restoreFocus) activeEntry?.focus({ preventScroll: true });
      views.forEach(view => { view.hidden = true; view.inert = true; });
      activeEntry = null;
    }

    entries.forEach(entry => listen(entry, 'click', () => {
      const view = views.find(candidate => candidate.id === entry.dataset.menuEnter);
      if (!view) return;
      activeEntry = entry;
      entry.setAttribute('aria-expanded', 'true');
      view.hidden = false;
      view.inert = false;
      dialog.setAttribute('aria-labelledby', view.getAttribute('aria-labelledby'));
      view.querySelector('.vn-mobile-menu__scroll').scrollTop = 0;
      view.querySelector('[data-menu-back]').focus({ preventScroll: true });
      home.hidden = true;
      home.inert = true;
    }));
    dialog.querySelectorAll('[data-menu-back]').forEach(button => listen(button, 'click', () => showHome(true)));

    function reflect(open) {
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'Cerrar menú' : 'Abrir menú');
      header.classList.toggle('vn-menu-abierto', open);
      document.documentElement.classList.toggle('vn-mobile-menu-open', !!document.querySelector('[data-vn-mobile-drawer][open]'));
    }

    function close(restoreFocus = true) {
      if (!isOpen()) return;
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
      reflect(false);
      if (restoreFocus && opener?.isConnected && opener.getClientRects().length) {
        opener.focus({ preventScroll: true });
      }
    }

    function open() {
      if (!mobile.matches || isOpen()) return;
      const active = document.activeElement;
      opener = active instanceof HTMLElement && active.tabIndex >= 0 &&
        !active.hasAttribute('disabled') && !dialog.contains(active) &&
        active.getClientRects().length ? active : toggle;
      showHome();
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      reflect(true);
      const scrollArea = dialog.querySelector('.vn-mobile-menu__scroll');
      if (scrollArea) scrollArea.scrollTop = 0;
      const closeButton = panel.querySelector('[data-vn-mobile-close]');
      closeButton?.focus({ preventScroll: true });
    }

    listen(toggle, 'click', () => isOpen() ? close() : open());
    dialog.querySelectorAll('[data-vn-mobile-close]').forEach(button => {
      listen(button, 'click', () => close());
    });
    listen(dialog, 'click', event => {
      if (event.target === dialog) close();
      if (event.target instanceof Element && event.target.closest('a[href]')) close(false);
    });
    listen(dialog, 'cancel', event => { event.preventDefault(); close(); });
    listen(dialog, 'close', () => reflect(isOpen()));
    listen(dialog, 'keydown', event => {
      if (event.key === 'Escape') { event.preventDefault(); close(); return; }
      if (event.key !== 'Tab') return;
      const focusable = [...panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), summary, [tabindex="0"]')]
        .filter(node => node.getClientRects().length && node.getAttribute('tabindex') !== '-1');
      if (!focusable.length) { event.preventDefault(); return; }
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && (document.activeElement === first || !panel.contains(document.activeElement))) {
        event.preventDefault(); last.focus();
      } else if (!event.shiftKey && (document.activeElement === last || !panel.contains(document.activeElement))) {
        event.preventDefault(); first.focus();
      }
    });
    listen(mobile, 'change', () => { if (!mobile.matches) close(false); });
    controllers.set(header, { destroy() { close(false); abort.abort(); controllers.delete(header); } });
  }

  function start(root = document) {
    if (root instanceof Element && root.matches('[data-vn-mobile-nav]')) initialize(root);
    root.querySelectorAll('[data-vn-mobile-nav]').forEach(initialize);
  }
  window.vnMobileMenu20261007 = { start };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(), { once: true });
  else start();
  document.addEventListener('shopify:section:load', event => start(event.target));
  document.addEventListener('shopify:section:unload', event => {
    controllers.forEach((controller, header) => {
      if (header === event.target || event.target.contains(header)) controller.destroy();
    });
  });
  window.addEventListener('pagehide', () => controllers.forEach(controller => controller.destroy()));
  window.addEventListener('pageshow', () => start());
})();
